import { LineGraphicProperties } from './3D/graphic-properties/line-graphic-properties.model';
import { FluidDatasheet } from './fluid-datasheet.model';
import { MeshInstructions } from './mesh-instructions';
import { SegmentConfig } from './segment-config.model';
import { SegmentMesh } from './segment-mesh.model';

export class Line {
  id: number;
  title: string;
  internalId: number;
  catenaryAnchorId: number;
  lineType: string;
  angle: number;
  tension: number;
  force: number;
  projection: number;
  offsetNear: number;
  offsetFar: number;
  azimuth: number;
  connectionId: number;
  pipeSituation: string;
  segment: number;
  segmentSoilId: number[];
  segmentMaterialId: number[];
  segFluidSpecificWeight: number[];
  segFluidAnnularWeight: number[];
  segmentBuoyId: number[];
  segmentTendonId: number[];
  segConfig: SegmentConfig[];
  segmentMesh: SegmentMesh[];
  meshPytzcurvesUpdate: boolean;
  meshPytzcurvesConsiderPy: boolean;
  meshPytzcurvesConsiderTz: boolean;
  meshPytzcurves: string;
  stingerBc: string;
  elasticDeformation: boolean;
  lineModel: boolean;
  lineUndeformed: boolean;
  lineMaxCurve: boolean;
  lineWire: boolean;
  lineLabel: boolean;
  lineNodeLabel: boolean;
  lineFeLabel: boolean;
  lineFeAxis: boolean;
  localAxes: boolean;
  lineExtrusion: boolean;
  extrusionFaces: number;
  extrusionFactor: number;
  extrusionTransp: number;
  lineFeMesh: boolean;
  lineThickness: number;
  linePipeLabel: boolean;
  calcType: number;
  fluidDatasheet: FluidDatasheet;
  fluidFunctionId: number;
  meshInstructions: MeshInstructions;

  needsUpdate?: boolean;
  graphicProperties?: LineGraphicProperties;

  horizontalTension: number;
  verticalTension: number;

  constructor() {}
}
